document.addEventListener('DOMContentLoaded', function () {
    const table = document.getElementById('sortable-table');
    const headers = table.querySelectorAll('th[data-sort]');
    const tbody = table.querySelector('tbody');
    const rows = tbody.querySelectorAll('tr'); // Get all rows

    // Add sorting functionality
    headers.forEach(header => {
        header.addEventListener('click', () => {
            const column = header.getAttribute('data-sort'); // Get column to sort
            const rows = Array.from(tbody.querySelectorAll('tr')); // Get all rows
            const isAscending = header.classList.contains('ascending'); // Check direction

            // Sort rows by column data-value
            rows.sort((rowA, rowB) => {
                const cellA = rowA.querySelector(`td[data-sort="${column}"]`);
                const cellB = rowB.querySelector(`td[data-sort="${column}"]`);

                // Use 0 for missing or invalid values during sorting
                const valueA = parseFloat(cellA?.dataset.value || '0');
                const valueB = parseFloat(cellB?.dataset.value || '0');

                return isAscending ? valueA - valueB : valueB - valueA;
            });

            // Append sorted rows to tbody
            rows.forEach(row => tbody.appendChild(row));

            // Reset and update sort direction classes
            headers.forEach(h => h.classList.remove('ascending', 'descending'));
            header.classList.toggle('ascending', !isAscending);
            header.classList.toggle('descending', isAscending);
        });
    });

    // Add click functionality for rows
    rows.forEach(row => {
        row.addEventListener('click', () => {
            const url = row.dataset.url; // Get the URL from data-url
            if (url) {
                window.location.href = url; // Redirect to the product page
            }
        });

        // Optional: Change cursor to pointer for clickable rows
        row.style.cursor = 'pointer';
    });
});
